import { createRoot } from "react-dom/client";
import LandingApp from "./LandingApp";
import "./index.css";

createRoot(document.getElementById("root")!).render(<LandingApp />);
